// Small rules the Active deals board and the booking calendar share (ART-331).

/** The sooner of a show date and its Good through (either may be absent), as `YYYY-MM-DD`. */
export function soonerOf(date: string | null | undefined, goodThrough: string | null | undefined): string | null {
  const a = date?.slice(0, 10) || null;
  const b = goodThrough?.slice(0, 10) || null;
  if (a && b) return a < b ? a : b;
  return a ?? b;
}

/** A board column → the booking calendar's `?type=` (ART-331): the Offer column is both pre-hold states. */
export function calendarTypeFor(column: string): string {
  return column === "offer" ? "offer" : column;
}
